export const leads = [
  {
    id: 1,
    title: "城郊工业园夜间偷排废水疑云",
    category: "环境安全",
    categoryId: "environment",
    region: "江苏 · 常州",
    time: "2026-09-08",
    summary:
      "连续多日深夜出现刺鼻气味与暗管排水，附近河道悬浮物明显增多，希望核实排放来源与相关环保手续是否齐全。",
    bounty: 3000,
    status: "征集中",
    hot: true,
    views: 4821,
    image:
      "https://readdy.ai/api/search-image?query=documentary%20photo%20of%20an%20industrial%20canal%20at%20dusk%20with%20murky%20water%20and%20steel%20pipes%2C%20overcast%20grey%20sky%2C%20desaturated%20tones%20with%20faint%20amber%20light%2C%20photojournalism%20style%2C%20serious%20investigative%20mood&width=800&height=560&seq=baoliao51-lead-env-01&orientation=landscape",
  },
  {
    id: 2,
    title: "某连锁培训机构退费拖延问题",
    category: "教育观察",
    categoryId: "education",
    region: "广东 · 佛山",
    time: "2026-09-06",
    summary:
      "家长反映课程停摆后迟迟未退费，涉及学员数量较多，需要更多报名合同与沟通记录作为佐证材料。",
    bounty: 1500,
    status: "征集中",
    hot: true,
    views: 3260,
    image:
      "https://readdy.ai/api/search-image?query=quiet%20empty%20classroom%20with%20stacked%20chairs%20and%20closed%20folders%20on%20desks%2C%20soft%20window%20light%2C%20warm%20neutral%20paper%20tones%2C%20documentary%20editorial%20photography%2C%20calm%20serious%20atmosphere&width=800&height=560&seq=baoliao51-lead-edu-02&orientation=landscape",
  },
  {
    id: 3,
    title: "电商平台刷单返现链条追踪",
    category: "网络乱象",
    categoryId: "online",
    region: "全国",
    time: "2026-09-05",
    summary:
      "招募兼职刷量、虚假好评返现的社群运营流程，需要更多一手聊天截图与结算流水来还原完整链条。",
    bounty: 5000,
    status: "重点线索",
    hot: true,
    views: 7132,
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20smartphone%20screen%20glowing%20in%20a%20dark%20room%20with%20blurred%20chat%20bubbles%2C%20cool%20shadow%20with%20crimson%20accent%20light%2C%20macro%20technology%20photography%2C%20mysterious%20digital%20investigation%20mood&width=800&height=560&seq=baoliao51-lead-online-03&orientation=landscape",
  },
  {
    id: 4,
    title: "老旧小区改造资金使用疑点",
    category: "民生关注",
    categoryId: "livelihood",
    region: "四川 · 绵阳",
    time: "2026-09-03",
    summary:
      "居民反映改造完成度与现场公示内容存在出入，需核实项目清单、施工记录与实际验收情况。",
    bounty: 2500,
    status: "征集中",
    hot: false,
    views: 1987,
    image:
      "https://readdy.ai/api/search-image?query=old%20residential%20community%20courtyard%20under%20renovation%20with%20scaffolding%20and%20notice%20boards%2C%20soft%20overcast%20daylight%2C%20muted%20warm%20earth%20tones%2C%20documentary%20urban%20photography%2C%20quiet%20observational%20style&width=800&height=560&seq=baoliao51-lead-city-04&orientation=landscape",
  },
  {
    id: 5,
    title: "二手车检测报告真实性争议",
    category: "消费维权",
    categoryId: "consumer",
    region: "河南 · 郑州",
    time: "2026-09-01",
    summary:
      "多份检测报告结论与实际车况不符，疑似出具机构与车商存在关联，欢迎提供同类遭遇与报告原件。",
    bounty: 2000,
    status: "征集中",
    hot: false,
    views: 2455,
    image:
      "https://readdy.ai/api/search-image?query=used%20car%20sitting%20in%20an%20outdoor%20dealer%20lot%20with%20clipboard%20and%20inspection%20documents%20on%20the%20hood%2C%20soft%20late%20afternoon%20light%2C%20warm%20neutral%20tones%2C%20editorial%20documentary%20photography%2C%20serious%20tone&width=800&height=560&seq=baoliao51-lead-car-05&orientation=landscape",
  },
  {
    id: 6,
    title: "某企业招聘承诺与合同不符",
    category: "职场内幕",
    categoryId: "workplace",
    region: "浙江 · 宁波",
    time: "2026-08-30",
    summary:
      "入职后薪资结构、加班补贴与面试承诺出入较大，希望收集同类员工的劳动合同与考勤记录。",
    bounty: 1200,
    status: "征集中",
    hot: false,
    views: 1612,
    image:
      "https://readdy.ai/api/search-image?query=empty%20modern%20office%20desk%20with%20signed%20contract%20papers%20and%20a%20coffee%20cup%2C%20dramatic%20side%20window%20light%2C%20muted%20warm%20beige%20and%20grey%20tones%2C%20documentary%20editorial%20photography%2C%20quiet%20tension&width=800&height=560&seq=baoliao51-lead-work-06&orientation=landscape",
  },
  {
    id: 7,
    title: "直播间保健品宣传用语调查",
    category: "行业黑幕",
    categoryId: "industry",
    region: "全国",
    time: "2026-08-28",
    summary:
      "部分主播在直播中使用绝对化疗效话术，疑似面向中老年群体定向营销，欢迎提供录屏与订单凭证。",
    bounty: 4000,
    status: "重点线索",
    hot: true,
    views: 6018,
    image:
      "https://readdy.ai/api/search-image?query=ring%20light%20and%20microphone%20on%20a%20live%20streaming%20desk%20with%20product%20bottles%2C%20warm%20crimson%20and%20amber%20studio%20lighting%2C%20dark%20background%2C%20commercial%20documentary%20photography%2C%20intense%20focus&width=800&height=560&seq=baoliao51-lead-live-07&orientation=landscape",
  },
  {
    id: 8,
    title: "网络理财平台异常提现线索",
    category: "财经线索",
    categoryId: "finance",
    region: "福建 · 厦门",
    time: "2026-08-26",
    summary:
      "平台承诺高收益后开始限制提现，客服陆续失联，需要更多投资凭证、推广记录与资金流水。",
    bounty: 6000,
    status: "重点线索",
    hot: true,
    views: 8320,
    image:
      "https://readdy.ai/api/search-image?query=financial%20documents%20and%20calculator%20on%20a%20wooden%20desk%20with%20a%20laptop%20showing%20a%20blank%20screen%2C%20warm%20low%20key%20lighting%2C%20amber%20and%20deep%20brown%20tones%2C%20editorial%20finance%20photography%2C%20serious%20mood&width=800&height=560&seq=baoliao51-lead-fin-08&orientation=landscape",
  },
  {
    id: 9,
    title: "社区团购生鲜品质波动问题",
    category: "消费维权",
    categoryId: "consumer",
    region: "湖北 · 武汉",
    time: "2026-08-24",
    summary:
      "多个小区集中反映到货不新鲜、缺斤少两，希望收集订单截图与实物对比照片作为参考。",
    bounty: 1000,
    status: "征集中",
    hot: false,
    views: 1204,
    image:
      "https://readdy.ai/api/search-image?query=fresh%20produce%20parcels%20on%20a%20table%20with%20a%20notepad%20and%20receipts%2C%20soft%20daylight%2C%20natural%20green%20and%20warm%20neutral%20tones%2C%20clean%20documentary%20still%20life%20photography%2C%20calm%20tone&width=800&height=560&seq=baoliao51-lead-fresh-09&orientation=landscape",
  },
];